// extracted by mini-css-extract-plugin
export default {"MessageOptionsWrapper":"MessageContextMenu_MessageOptionsWrapper__pEsFS","Text":"MessageContextMenu_Text__jVDpH","IconWrapper":"MessageContextMenu_IconWrapper__wIMR9"};